import { TASKS_ANCHORS, TASKS_CONTEXTS } from './anchors'
import { SHARED_ANCHORS } from '../shared/anchors'
import { withScopes } from '../shared/scopes'
import { taskCardSteps } from '../shared/steps'
import type { IOnboardingScenario } from '../../types/IOnboardingScenario'
import type { IOnboardingStep } from '../../types/IOnboardingStep'

const { table } = TASKS_ANCHORS
const ctx = TASKS_CONTEXTS

/* filtersPanel — раскрытая панель «Фильтры» на мобильном (на десктопе действие ничего не делает) */
const tableSteps: IOnboardingStep[] = [
  { id: 'tasks.intro', anchors: [], context: ctx.table },
  { id: 'tasks.create', anchors: [table.create], context: ctx.table },
  { id: 'tasks.search', anchors: [table.search], context: ctx.table },
  ...withScopes(['filtersPanel'], [
    { id: 'tasks.role', anchors: [table.role], context: ctx.table },
    { id: 'tasks.source', anchors: [table.source], context: ctx.table },
    { id: 'tasks.quickFilters', anchors: [table.quickFirst, table.quickLast], context: ctx.table },
    { id: 'tasks.resetFilters', anchors: [table.resetFilters], context: ctx.table },
  ]),
  { id: 'tasks.hideCompleted', anchors: [table.hideCompleted], context: ctx.table },
  { id: 'tasks.filters', anchors: [table.filterFirst, table.filterLast], context: ctx.table },
  { id: 'tasks.demoRowMenu', anchors: [table.demoRowMenu], context: ctx.table },
  { id: 'tasks.demoRow', anchors: [table.demoRow], context: ctx.table },
]

const cardSteps: IOnboardingStep[] = withScopes(['card'], [
  ...taskCardSteps(ctx.card),
  { id: 'tasks.card.chat', anchors: [SHARED_ANCHORS.demoChat], context: ctx.card, placement: 'left' },
  { id: 'ear.link', anchors: [SHARED_ANCHORS.ear.link], context: ctx.card, placement: 'left' },
  { id: 'ear.onboarding', anchors: [SHARED_ANCHORS.ear.onboarding], context: ctx.card, placement: 'left' },
])

export const tasksScenarios: IOnboardingScenario[] = [
  {
    id: 'tasks',
    section: 'responsibility_entry',
    isMain: true,
    scopes: {
      filtersPanel: { open: { context: ctx.table, action: 'openFiltersPanel' } },
      card: {
        open: { context: ctx.table, action: 'openDemoCard' },
        close: { context: ctx.table, action: 'closeCard' },
      },
    },
    steps: [...tableSteps, ...cardSteps],
  },
  {
    id: 'tasks.card',
    section: 'responsibility_entry',
    isMain: false,
    scopes: {
      card: {
        open: { context: ctx.card, action: 'showDemo' },
        close: { context: ctx.card, action: 'showReal' },
      },
    },
    steps: cardSteps,
  },
]
